// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base {
        position: relative;

        display: flex;
        flex-direction: column;

        width: 100vw;
        height: 100vh;

        overflow: hidden;
}

.header {
        position: relative;

        height: 50px;
        min-height: 50px;

        display: flex;
        align-items: center;
        justify-content: space-between;

        box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);
}

.header_left {
        display: flex;
        align-items: center;
        gap: 30px;
        width: 100%;
        min-width: -webkit-min-content;

        padding-left: 20px;
}

.nav_item {
        list-style-type: none;

        font-family: 'Montserrat';
        font-size: 12px;
        font-weight: 500;

        cursor: pointer;

        padding: 0;
}

.nav_item.suite {
        cursor: auto;

        display: flex;
        align-items: center;
        gap: 5px;
}

.nav_item_label {
        cursor: pointer;
}

.nav_item_arrow {
        height: 10px;
}

.nav_item_tool {
        display: flex;
        align-items: center;
        gap: 5px;
}

.nav_item_icon {
        height: 12px;
        margin-top: -2px;
}

.nav_item_label:hover {
        color: #C56050;
}

.nav_item:hover {
        color: #C56050;
}

.nav_item.suite:hover {
        color: #000;
}

.header_left_separatedLogo {
        height: 100%;

        display: flex;
        align-items: center;

        padding-left: 20px;
}

.header_left_separatedLogo > img {
        height: 30px;
}

.header_center {
        height: 100%;

        display: flex;
        gap: 2px;
        flex-shrink: 0;

        margin: 0 20px;
}

.header_datamatics_container {
        height: 100%;
        padding-top: 17px;
}

.header_datamatics {
        height: 20px;
        /* filter: saturate(0); */
}

.header_datamatics.true {
        height: 30px;
        filter: none;
        margin-top: -5px;
}

.header_appNameContainer {
        font-family: "Figtree";
        font-size: 25px;
        font-weight: 600;

        color: #C00D0D;

        height: 18px;
        line-height: 19px;

        margin-top: 17px;
}

.header_right {
        height: 100%;
        width: 100%;
        min-width: -webkit-min-content;

        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 20px;
}

.header_profileIconContainer {
        display: flex;
        align-items: center;
        gap: 10px;
        height: 100%;

        padding: 0 20px;

        cursor: pointer;
}

.header_profileIconContainer:hover {
        background-color: #f0f0f0;
}

.header_profileIcon_info {
        font-family: "Montserrat";
        text-align: right;
        height: 100%;
        padding-top: 28px;
}

.header_profileIcon_name {
        font-size: 12px;
        font-weight: 700;
        line-height: 11px;
        height: 10px;
}

.header_profileIcon_role {
        font-size: 10px;
        font-weight: 500;
        line-height: 9px;

        margin-top: 4.5px;
        height: 9px;
}

img.header_profileIcon {
        height: 30px;
        border-radius: 50%;
}

.header_right > img {
        height: 15px;
        cursor: pointer;
}

img.header_appName {
        filter: contrast(25%)
                sepia(100%)
                hue-rotate(320deg)
                saturate(300%);

        cursor: auto;
}

.bodyWrapper {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;

        width: 100%;
}

.contentWrapper {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;
        background-color: #F7F3F0;

        width: 100%;
}

.info-box {
        position: fixed;
        top: 45px;
        right: 175px;
        z-index: 2;

        box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
        border: 1px solid #e4e4e4;

        width: 350px;
        height: -moz-fit-content;
        height: fit-content;

        background: #fff;
        padding: 20px;

        white-space: pre-line;
}

.profile-box {
        position: fixed;
        top: 55px;
        right: 10px;

        box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
        border: 1px solid #e4e4e4;
        border-radius: 6px;

        width: -moz-fit-content;

        width: fit-content;

        background: #fff;

        padding: 15px;
        gap: 12.5px;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        font-family: "Montserrat";
}

.profile-closeContainer {
        height: 30px;
        aspect-ratio: 1;
        border-top-right-radius: 15px;

        position: absolute;
        top: 0;
        right: 0;

        align-items: center;
        justify-content: center;

        transition: background 0.2s ease;
}

.profile-close {
        height: 12px;
        cursor: pointer;

        padding: 10px;

        border-top-right-radius: 15px;

        transition: filter 0.2s ease;
}

.profile-closeContainer:hover {
        background: red;
}

.profile-close:hover {
        filter: brightness(0) invert(1);
}


.profile-image {
        width: 60px;
        height: 60px;
        border-radius: 50%;
}

.profile-name {
        font-size: 14px;
        font-weight: bold;
        margin-top: 15px;
        text-align: center;
}

.profile-details {
        text-align: center;
}

.profile-email,
.profile-designation {
        font-size: 12px;
        color: #777;
        white-space: wrap;
        text-wrap: wrap;
        margin-top: 5px;
}

.logout-button {
        background-color: #ff4d4f;
        color: #fff;
        border: none;
        padding: 8px 12px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: background-color 0.3s ease-in-out;
        margin-top: 10px;
}

.logout-button:hover {
        background-color: #d9363e;
}

.modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background-color: rgba(0, 0, 0, 0.01);
}
.header_profileIconFallback {
        width: 35px; 
        height: 35px; 
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ccc; 
        border-radius: 50%;
        font-size: 18px; 
        color: white; 
      }
`, "",{"version":3,"sources":["webpack://./src/components/Base/Base.css"],"names":[],"mappings":"AAAA;QACQ,kBAAkB;;QAElB,aAAa;QACb,sBAAsB;;QAEtB,YAAY;QACZ,aAAa;;QAEb,gBAAgB;AACxB;;AAEA;QACQ,kBAAkB;;QAElB,YAAY;QACZ,gBAAgB;;QAEhB,aAAa;QACb,mBAAmB;QACnB,8BAA8B;;QAE9B,yCAAyC;AACjD;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,WAAW;QACX,8BAA8B;;QAE9B,kBAAkB;AAC1B;;AAEA;QACQ,qBAAqB;;QAErB,yBAAyB;QACzB,eAAe;QACf,gBAAgB;;QAEhB,eAAe;;QAEf,UAAU;AAClB;;AAEA;QACQ,YAAY;;QAEZ,aAAa;QACb,mBAAmB;QACnB,QAAQ;AAChB;;AAEA;QACQ,eAAe;AACvB;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,QAAQ;AAChB;;AAEA;QACQ,YAAY;QACZ,gBAAgB;AACxB;;AAEA;QACQ,cAAc;AACtB;;AAEA;QACQ,cAAc;AACtB;;AAEA;QACQ,WAAW;AACnB;;AAEA;QACQ,YAAY;;QAEZ,aAAa;QACb,mBAAmB;;QAEnB,kBAAkB;AAC1B;;AAEA;QACQ,YAAY;AACpB;;AAEA;QACQ,YAAY;;QAEZ,aAAa;QACb,QAAQ;QACR,cAAc;;QAEd,cAAc;AACtB;;AAEA;QACQ,YAAY;QACZ,iBAAiB;AACzB;;AAEA;QACQ,YAAY;QACZ,yBAAyB;AACjC;;AAEA;QACQ,YAAY;QACZ,YAAY;QACZ,gBAAgB;AACxB;;AAEA;QACQ,sBAAsB;QACtB,eAAe;QACf,gBAAgB;;QAEhB,cAAc;;QAEd,YAAY;QACZ,iBAAiB;;QAEjB,gBAAgB;AACxB;;AAEA;QACQ,YAAY;QACZ,WAAW;QACX,8BAA8B;;QAE9B,aAAa;QACb,mBAAmB;QACnB,yBAAyB;QACzB,SAAS;AACjB;;AAEA;QACQ,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,YAAY;;QAEZ,eAAe;;QAEf,eAAe;AACvB;;AAEA;QACQ,yBAAyB;AACjC;;AAEA;QACQ,yBAAyB;QACzB,iBAAiB;QACjB,YAAY;QACZ,iBAAiB;AACzB;;AAEA;QACQ,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;AACpB;;AAEA;QACQ,eAAe;QACf,gBAAgB;QAChB,gBAAgB;;QAEhB,iBAAiB;QACjB,WAAW;AACnB;;AAEA;QACQ,YAAY;QACZ,kBAAkB;AAC1B;;AAEA;QACQ,YAAY;QACZ,eAAe;AACvB;;AAEA;QACQ;;;8BAGsB;;QAEtB,YAAY;AACpB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;;QAEhB,WAAW;AACnB;;AAEA;QACQ,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;QAChB,yBAAyB;;QAEzB,WAAW;AACnB;;AAEA;QACQ,eAAe;QACf,SAAS;QACT,YAAY;QACZ,UAAU;;QAEV,wCAAwC;QACxC,yBAAyB;;QAEzB,YAAY;QACZ,wBAAmB;QAAnB,mBAAmB;;QAEnB,gBAAgB;QAChB,aAAa;;QAEb,qBAAqB;AAC7B;;AAEA;QACQ,eAAe;QACf,SAAS;QACT,WAAW;;QAEX,wCAAwC;QACxC,yBAAyB;QACzB,kBAAkB;;QAElB,uBAAkB;;QAAlB,kBAAkB;;QAElB,gBAAgB;;QAEhB,aAAa;QACb,WAAW;;QAEX,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,8BAA8B;;QAE9B,yBAAyB;AACjC;;AAEA;QACQ,YAAY;QACZ,eAAe;QACf,6BAA6B;;QAE7B,kBAAkB;QAClB,MAAM;QACN,QAAQ;;QAER,mBAAmB;QACnB,uBAAuB;;QAEvB,gCAAgC;AACxC;;AAEA;QACQ,YAAY;QACZ,eAAe;;QAEf,aAAa;;QAEb,6BAA6B;;QAE7B,4BAA4B;AACpC;;AAEA;QACQ,eAAe;AACvB;;AAEA;QACQ,+BAA+B;AACvC;;;AAGA;QACQ,WAAW;QACX,YAAY;QACZ,kBAAkB;AAC1B;;AAEA;QACQ,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;AAC1B;;AAEA;QACQ,kBAAkB;AAC1B;;AAEA;;QAEQ,eAAe;QACf,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,eAAe;AACvB;;AAEA;QACQ,yBAAyB;QACzB,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,eAAe;QACf,6CAA6C;QAC7C,gBAAgB;AACxB;;AAEA;QACQ,yBAAyB;AACjC;;AAEA;QACQ,eAAe;QACf,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY;QACZ,UAAU;QACV,qCAAqC;AAC7C;AACA;QACQ,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,sBAAsB;QACtB,kBAAkB;QAClB,eAAe;QACf,YAAY;MACd","sourcesContent":[".base {\n        position: relative;\n\n        display: flex;\n        flex-direction: column;\n\n        width: 100vw;\n        height: 100vh;\n\n        overflow: hidden;\n}\n\n.header {\n        position: relative;\n\n        height: 50px;\n        min-height: 50px;\n\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        box-shadow: 0 0px 10px rgba(0, 0, 0, 0.1);\n}\n\n.header_left {\n        display: flex;\n        align-items: center;\n        gap: 30px;\n        width: 100%;\n        min-width: -webkit-min-content;\n\n        padding-left: 20px;\n}\n\n.nav_item {\n        list-style-type: none;\n\n        font-family: 'Montserrat';\n        font-size: 12px;\n        font-weight: 500;\n\n        cursor: pointer;\n\n        padding: 0;\n}\n\n.nav_item.suite {\n        cursor: auto;\n\n        display: flex;\n        align-items: center;\n        gap: 5px;\n}\n\n.nav_item_label {\n        cursor: pointer;\n}\n\n.nav_item_arrow {\n        height: 10px;\n}\n\n.nav_item_tool {\n        display: flex;\n        align-items: center;\n        gap: 5px;\n}\n\n.nav_item_icon {\n        height: 12px;\n        margin-top: -2px;\n}\n\n.nav_item_label:hover {\n        color: #C56050;\n}\n\n.nav_item:hover {\n        color: #C56050;\n}\n\n.nav_item.suite:hover {\n        color: #000;\n}\n\n.header_left_separatedLogo {\n        height: 100%;\n\n        display: flex;\n        align-items: center;\n\n        padding-left: 20px;\n}\n\n.header_left_separatedLogo > img {\n        height: 30px;\n}\n\n.header_center {\n        height: 100%;\n\n        display: flex;\n        gap: 2px;\n        flex-shrink: 0;\n\n        margin: 0 20px;\n}\n\n.header_datamatics_container {\n        height: 100%;\n        padding-top: 17px;\n}\n\n.header_datamatics {\n        height: 20px;\n        /* filter: saturate(0); */\n}\n\n.header_datamatics.true {\n        height: 30px;\n        filter: none;\n        margin-top: -5px;\n}\n\n.header_appNameContainer {\n        font-family: \"Figtree\";\n        font-size: 25px;\n        font-weight: 600;\n\n        color: #C00D0D;\n\n        height: 18px;\n        line-height: 19px;\n\n        margin-top: 17px;\n}\n\n.header_right {\n        height: 100%;\n        width: 100%;\n        min-width: -webkit-min-content;\n\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 20px;\n}\n\n.header_profileIconContainer {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        height: 100%;\n\n        padding: 0 20px;\n\n        cursor: pointer;\n}\n\n.header_profileIconContainer:hover {\n        background-color: #f0f0f0;\n}\n\n.header_profileIcon_info {\n        font-family: \"Montserrat\";\n        text-align: right;\n        height: 100%;\n        padding-top: 28px;\n}\n\n.header_profileIcon_name {\n        font-size: 12px;\n        font-weight: 700;\n        line-height: 11px;\n        height: 10px;\n}\n\n.header_profileIcon_role {\n        font-size: 10px;\n        font-weight: 500;\n        line-height: 9px;\n\n        margin-top: 4.5px;\n        height: 9px;\n}\n\nimg.header_profileIcon {\n        height: 30px;\n        border-radius: 50%;\n}\n\n.header_right > img {\n        height: 15px;\n        cursor: pointer;\n}\n\nimg.header_appName {\n        filter: contrast(25%)\n                sepia(100%)\n                hue-rotate(320deg)\n                saturate(300%);\n\n        cursor: auto;\n}\n\n.bodyWrapper {\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n        overflow: hidden;\n\n        width: 100%;\n}\n\n.contentWrapper {\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n        overflow: hidden;\n        background-color: #F7F3F0;\n\n        width: 100%;\n}\n\n.info-box {\n        position: fixed;\n        top: 45px;\n        right: 175px;\n        z-index: 2;\n\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n        border: 1px solid #e4e4e4;\n\n        width: 350px;\n        height: fit-content;\n\n        background: #fff;\n        padding: 20px;\n\n        white-space: pre-line;\n}\n\n.profile-box {\n        position: fixed;\n        top: 55px;\n        right: 10px;\n\n        box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n        border: 1px solid #e4e4e4;\n        border-radius: 6px;\n\n        width: fit-content;\n\n        background: #fff;\n\n        padding: 15px;\n        gap: 12.5px;\n\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-between;\n\n        font-family: \"Montserrat\";\n}\n\n.profile-closeContainer {\n        height: 30px;\n        aspect-ratio: 1;\n        border-top-right-radius: 15px;\n\n        position: absolute;\n        top: 0;\n        right: 0;\n\n        align-items: center;\n        justify-content: center;\n\n        transition: background 0.2s ease;\n}\n\n.profile-close {\n        height: 12px;\n        cursor: pointer;\n\n        padding: 10px;\n\n        border-top-right-radius: 15px;\n\n        transition: filter 0.2s ease;\n}\n\n.profile-closeContainer:hover {\n        background: red;\n}\n\n.profile-close:hover {\n        filter: brightness(0) invert(1);\n}\n\n\n.profile-image {\n        width: 60px;\n        height: 60px;\n        border-radius: 50%;\n}\n\n.profile-name {\n        font-size: 14px;\n        font-weight: bold;\n        margin-top: 15px;\n        text-align: center;\n}\n\n.profile-details {\n        text-align: center;\n}\n\n.profile-email,\n.profile-designation {\n        font-size: 12px;\n        color: #777;\n        white-space: wrap;\n        text-wrap: wrap;\n        margin-top: 5px;\n}\n\n.logout-button {\n        background-color: #ff4d4f;\n        color: #fff;\n        border: none;\n        padding: 8px 12px;\n        border-radius: 4px;\n        cursor: pointer;\n        font-size: 14px;\n        transition: background-color 0.3s ease-in-out;\n        margin-top: 10px;\n}\n\n.logout-button:hover {\n        background-color: #d9363e;\n}\n\n.modal-overlay {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 1;\n        background-color: rgba(0, 0, 0, 0.01);\n}\n.header_profileIconFallback {\n        width: 35px; \n        height: 35px; \n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: #ccc; \n        border-radius: 50%;\n        font-size: 18px; \n        color: white; \n      }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
